import Contact from "../../../components/common/contact";

const ContactPage = () => {
    return (

        <Contact/>
    )
}

export default ContactPage;